import React from 'react';

const Spoke = ({num, speed}) => (<span className={`spoke num-${num}`}>
        <span style={{transitionDuration:  `${speed}ms`}}/>
        <span style={{transitionDuration:  `${speed}ms`}}/>
        <span style={{transitionDuration:  `${speed}ms`}}/>
        <span style={{transitionDuration:  `${speed}ms`}}/>
        <span style={{transitionDuration:  `${speed}ms`}}/>
    </span>);

export default Spoke;
